<template>
  <!-- 可拖动设置窗口 -->
  <drag-wrap
    v-if="saleVisible"
    :visible="saleVisible"
    modalId="course-sale"
    modalName="直播销售"
  >
    <div class="course-sale-component">
      <div class="dialog-header">
        <h1>课程售卖({{ courseList.length }}/10)</h1>
        <img
          class="close-button"
          src="@saas/pages/assets/images/live/live-set/close-icon.png"
          @click="handleClose"
        />
      </div>
      <el-container class="sale-container can-not-drag-wrap">
        <div class="content-box">
          <div class="top-box">
            <div
              class="add-btn"
              v-if="!isSale && courseList.length < 10"
              @click.stop="addCourse"
            >
              <img src="@saas/pages/assets/images/live/sale/add.png" alt="" />
              添加商品
            </div>
            <div class="sale-text" v-else-if="isSale">售卖进行中，不可修改</div>
          </div>
          <div class="course-list">
            <div
              class="course-item"
              v-for="(item, index) in courseList"
              :key="index"
            >
              <div class="course-title">
                <span>商品链接{{ index + 1 }}</span>
                <img
                  v-if="!isSale"
                  @click.stop="deleteCourse(index)"
                  src="@saas/pages/assets/images/live/sale/delete.png"
                  alt=""
                />
              </div>
              <div class="course-content">
                <div class="course-url">
                  {{ webUrl }}/product-detail/
                  <span v-if="isSale">{{ item.id }}</span>
                </div>
                <input
                  class="course-input"
                  maxlength="18"
                  v-model="item.id"
                  placeholder="请输入课程ID"
                  v-if="!isSale"
                  @change="(e) => handleInput(e, index)"
                />
              </div>
              <div class="error-text">{{ item.errorText }}</div>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div v-if="isSale" class="stop-btn btn" @click.stop="stopSale">
            停止售卖
          </div>
          <div v-else class="start-btn btn" @click.stop="startSale">
            {{ publishBtnText }}
          </div>
        </div>
      </el-container>
    </div>
  </drag-wrap>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { DragWrap } from "@saas/components";
import {
  getRoomCart,
  publishRoomCart,
  stopRoomCart,
} from "@saas/server-api/src/live-sdk";
export default {
  name: "CourseSale",
  data() {
    return {
      lessonId: 0,
      saleVisible: false,
      isSale: false,
      courseList: [],
      saleInfo: {},
      isPublishing: false,
      publishBtnText: "开始售卖",
      publishTimer: null,
      webUrl: process.env.VUE_APP_SAAS_WEB_URL,
    };
  },
  components: {
    DragWrap,
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "userStatus",
      "roomInfo",
      "showCourseSale",
    ]),
    tips() {
      return this.isSale
        ? "售卖进行中，不可修改"
        : "您可以在此管理售卖课程的链接，最多可以设置 10 个，学员可在直播及观看回放时查看并购买课程，可以有效提升您的收入。";
    },
  },
  watch: {
    showCourseSale: {
      handler(val) {
        this.saleVisible = val;
        if (val) {
          this.getSaleInfo();
        }
      },
      deep: true,
    },
    "roomInfo.id"(val) {
      if (val) {
        this.getSaleInfo();
      }
    },
  },
  methods: {
    ...mapMutations("live", ["setShowCourseSale"]),
    // 处理关闭事件
    handleClose() {
      this.saleVisible = false;
      this.setShowCourseSale(false);
    },
    addCourse() {
      if (String(this.publishBtnText).length === 1) {
        return;
      }
      this.courseList.push({
        id: "",
        errorText: "",
      });
    },
    deleteCourse(index) {
      if (String(this.publishBtnText).length === 1) {
        return;
      }
      this.courseList.splice(index, 1);
      this.validity();
    },
    checkReplace(val) {
      return (
        this.courseList.filter((item) => Number(item.id) === Number(val))
          .length > 1
      );
    },
    handleInput(e, index) {
      // 过滤掉非0-9的字符
      const val = e.target.value.replace(/[^\d]/g, "");
      this.courseList[index].id = val;
      if (!val) {
        this.courseList[index].errorText = "请输入课程ID";
      } else if (this.checkReplace(val)) {
        this.courseList[index].errorText = "课程ID已存在";
      } else {
        this.courseList[index].errorText = "";
      }
    },
    validity() {
      if (this.courseList.length === 0) {
        this.$message.error("请添加售卖课程");
        return false;
      } else {
        let isOk = true;
        this.courseList.forEach((item) => {
          if (!item.id) {
            isOk = false;
            item.errorText = "请输入课程ID";
          } else if (this.checkReplace(item.id)) {
            isOk = false;
            item.errorText = "课程ID已存在";
          } else {
            item.errorText = "";
          }
        });
        return isOk;
      }
    },
    startSale() {
      if (!this.validity()) {
        return;
      }
      if (this.isPublishing) {
        return;
      } else {
        this.isPublishing = true;
      }

      publishRoomCart({
        course_ids: this.courseList.map((item) => +item.id),
        course_id: this.roomInfo.course_id,
        publish_time: this.getRoomDuration(),
        room_id: +this.roomInfo.id,
        lesson_id: this.roomInfo.lesson_id,
      })
        .then((res) => {
          if (res.code === 1) {
            // this.$message.success('发布成功')
            this.saleInfo = res.data || {};
            this.courseList = (this.saleInfo.course_ids || []).map((item) => {
              return {
                id: item,
                errorText: "",
              };
            });
            this.publishBtnText = 3;
            clearInterval(this.publishTimer);
            this.publishTimer = setInterval(() => {
              if (this.publishBtnText <= 1) {
                this.isSale = true;
                this.isPublishing = false;
                this.publishBtnText = "发布售卖";
                clearInterval(this.publishTimer);
              } else {
                this.publishBtnText -= 1;
              }
            }, 1000);
          } else if (res.code === 20021) {
            const errList = res.data || [];
            errList.forEach((item) => {
              this.courseList.forEach((course) => {
                if (String(course.id) === String(item.course_id)) {
                  course.errorText = item.err_msg;
                }
              });
            });
            this.isPublishing = false;
          } else {
            this.$message.error(res.message);
            this.isPublishing = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.isPublishing = false;
        });
    },
    getRoomDuration() {
      const now = Math.ceil(new Date().getTime() / 1000);
      return now - this.roomInfo.room_start_time;
    },
    stopSale() {
      stopRoomCart({
        id: this.saleInfo.id,
        room_id: +this.roomInfo.id,
        lesson_id: this.roomInfo.lesson_id,
        course_id: this.roomInfo.course_id,
        stop_time: this.getRoomDuration(),
      }).then((res) => {
        if (res.code === 1) {
          this.isSale = false;
          this.$message.success("停止成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取售卖信息
    getSaleInfo() {
      if (!this.roomInfo.id) {
        return;
      }
      getRoomCart({
        room_id: this.roomInfo.id,
        course_id: this.roomInfo.course_id,
      }).then((res) => {
        if (res.code === 1) {
          this.saleInfo = res.data || {};
          let courseList = [];
          if (this.saleInfo.room_id) {
            // 如果有房间id 代表是当前直播间售卖
            this.isSale = this.saleInfo.status === 1;
            courseList = this.saleInfo.course_ids || [];
          } else {
            // 如果没有房间id 代表是课程里其他课时售卖过
            courseList = this.saleInfo.last_course_ids || [];
            this.isSale = false;
          }
          if (!this.isSale && !courseList.length) {
            this.courseList = [
              {
                id: "",
                errorText: "",
              },
            ];
          } else {
            this.courseList = courseList.map((item) => {
              return {
                id: item,
                errorText: "",
              };
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
// Using SCSS variables if available, otherwise define colors directly
$dark-bg: #18181b; // Example dark background color
$dark-text: #ecedee; // Example light text color
$border-color: #27272a; // Example border color
$menu-active-bg: rgba(
  22,
  93,
  255,
  0.2
); // Example background for active menu item
$aside-width: 182px; // Adjust aside width to match desired look
$dialog-width: 658px; // Example dialog width
$dialog-height: 640px; // Example dialog height
$active-color: #165dff; // Example active color (Element UI primary blue)

.course-sale-component {
  width: $dialog-width;
  height: $dialog-height;
  color: $dark-text;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: $dark-bg;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 12px 12px;
  border: 2px solid #27272a;
}

.dialog-header {
  // padding: 10px 16px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid $border-color;
  flex-shrink: 0;
  height: 48px;
  display: flex;
  align-items: center;

  h1 {
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    margin: 0 auto;
  }

  .close-button {
    position: absolute;
    right: 17px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    cursor: pointer;
    color: #71717a;
    padding: 3px;
    width: 30px;
    height: 30px;
  }
}
.tips-box {
  z-index: 9999;
  display: none;
  position: absolute;
  left: 0;
  top: 24px;
  padding: 20px;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  background: rgba(30, 30, 31, 0.9);
  border-radius: 12px;
  font-weight: normal;
  width: 300px;
}
.content-box {
  flex: 1;
  width: 100%;
  padding: 24px 48px;
  overflow-y: auto;
  position: relative;
  .top-box {
    .add-btn {
      height: 40px;
      width: 132px;
      background: #28282a;
      border-radius: 6px;
      color: #e8f3ff;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
    .sale-text {
      height: 25px;
      font-weight: 400;
      font-size: 18px;
      color: #ff604e;
      line-height: 25px;
      text-align: left;
      font-style: normal;
    }
  }
  .course-list {
    height: 430px;
    overflow: auto;
    .course-item {
      &:first-child {
        margin-top: 24px;
      }
      .error-text {
        /* margin-top: 24px; */
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        color: rgba(255, 96, 78, 1);
      }
      .course-title {
        color: #fff;
        height: 25px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
      .course-content {
        width: 100%;
        height: 50px;
        background: #1e1e1f;
        border-radius: 6px;
        border: 1px solid #28282a;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 12px;
        .course-url {
          color: rgba(116, 117, 115, 1);
          font-size: 16px;
          flex: 1;
          padding-left: 6px;
        }
        .course-input {
          width: 170px;
          height: 100%;
          border: none;
          border-left: 1px solid #28282a;
          background: transparent;
          color: #fff;
          font-size: 16px;
          padding-left: 12px;
        }
      }
    }
  }
}
.bottom-box {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(23, 23, 24, 0) 0%, #171718 100%);
  border-radius: 0 0 12px 12px;
  .btn {
    width: 150px;
    height: 46px;
    border-radius: 6px;
    line-height: 46px;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    margin: 0 auto;
    margin-top: 36px;
    cursor: pointer;
  }
  .start-btn {
    background: #165dff;
    color: #ffffff;
  }
  .stop-btn {
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    background: #cb2634;
  }
}
.drag-wrap input:focus-visible {
  outline: none;
}
</style>
